import React, { forwardRef } from 'react';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { IBoxFormTextField } from 'src/components/profileComponents/FormTextField/types';
import { useStyles as commonUseStyles } from 'src/components/profileComponents/Users/styles';
import { useStyles } from './styles';

export const UserInput = forwardRef<HTMLInputElement, IBoxFormTextField>(({
  label, startAdornment, placeholder, name, value, onChange, onBlur,
}, ref) => {
  const commonStyles = commonUseStyles();
  const styles = useStyles();
  return (
    <div className={`${commonStyles.commonInput} ${styles.input}`}>
      <BoxFormTextField
        ref={ref}
        startAdornment={startAdornment}
        placeholder={placeholder}
        label={label}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
      />
    </div>
  );
});
